module.exports = __webpack_public_path__ + "static/img/logo-1.c9d76e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-1.png
// module id = xReq
// module chunks = 1